import { render, staticRenderFns } from "./goCusSerCenter.vue?vue&type=template&id=731c3a9e"
import script from "./goCusSerCenter.vue?vue&type=script&lang=js"
export * from "./goCusSerCenter.vue?vue&type=script&lang=js"
import style0 from "./goCusSerCenter.vue?vue&type=style&index=0&id=731c3a9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports